import { ReactElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

/**
 * Encode svg image in UTF-8 format;
 */
export const encodeSvg = (el: ReactElement) =>
    `data:image/svg+xml;charset=utf-8,${encodeURIComponent(renderToStaticMarkup(el))}`;
